import { render, staticRenderFns } from "./LaudoEditarSinalizador.vue?vue&type=template&id=e0d17856&"
import script from "./LaudoEditarSinalizador.vue?vue&type=script&lang=js&"
export * from "./LaudoEditarSinalizador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports